"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connector = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const HrLine_1 = require("../../components/blocks/hr/HrLine");
const settings_1 = require("./settings");
const connectorClass = (0, nano_theme_1.rule)({
    pos: 'absolute',
    l: '50%',
    transform: 'translateX(-50%)',
    bottom: `-${settings_1.ITEM_GAP - 4}px`,
    d: 'flex',
    fld: 'column',
    ai: 'center',
    trs: 'color .12s ease',
});
/** Vertical line connecting one step's bullet to the next step's bullet. */
const Connector = ({ style, color, width, top }) => {
    if (style === 'none' || width <= 0)
        return null;
    return (React.createElement("span", { className: connectorClass, style: { top: `${top}px`, color } },
        React.createElement(HrLine_1.HrLine, { orientation: "vertical", strokeWidth: width, style: style })));
};
exports.Connector = Connector;
